const state = {
  events: [],
  eventFiles: [],
  eventUsers: [],
  eventRoles: [],
  eventTypes: [],
  eventSkills: [],
  eventTransfers: [],
  eventEmployees: [],
  event: {
    id: 0,
    full_name: '',
    short_name: '',
    started_at: new Date(),
    ended_at: new Date(),
    day_c_1: new Date(),
    location: '',
    description: '',
    type: '',
    created_at: '',
    updated_at: '',
    notifications_policies: {
      manual: "system_only",
      control_point_request_created: "system_only",
      control_point_request_resolved: "system_only",
      critical_control_point_closure_requested: "system_only",
      critical_control_point_closure_resolved: "system_only",
      project_completed: "system_only",
      control_point_deadline_approaching: "system_only"
    }
  },
  eventEmployeesFilters: {
    role: undefined,
    organizationID: undefined,
    fndID: undefined,
  },
};

export default state;
